module.exports = __webpack_public_path__ + "static/altnerete-ekip-uptade-c7bd2d938cddacb898e2e123d46f37f6.webp";